import {
  ImagerCapabilitiesAction,
  EImagerCapabilitiesAction,
} from "../actions/ImagerCapabilitiesActions";
import { ImagerCapability } from "../../Model/ImagerCapabilities";
import { RootState } from "./RootReducer";
import { Collection } from "../../Model/Collection";
import { FetchStatus } from "../../Model/FetchStatus";

type State = {
  imagerCapabilities: Collection<ImagerCapability> | null;
  status: FetchStatus;
};

const initialState: State = {
  imagerCapabilities: null,
  status: {
    pending: false,
    completed: false,
    error: null,
  },
};

export function imagerCapabilitiesReducer(
  state = initialState,
  action: ImagerCapabilitiesAction
): State {
  switch (action.type) {
    case EImagerCapabilitiesAction.FETCH_IMAGER_CAPABILITIES_PENDING:
      return {
        status: {
          pending: true,
          completed: false,
          error: null,
        },
        imagerCapabilities: null,
      };
    case EImagerCapabilitiesAction.FETCH_IMAGER_CAPABILITIES_SUCCESS:
      return {
        status: {
          pending: false,
          completed: true,
          error: null,
        },
        imagerCapabilities: action.imagerCapabilities,
      };
    case EImagerCapabilitiesAction.FETCH_IMAGER_CAPABILITIES_ERROR:
      return {
        status: {
          pending: false,
          completed: true,
          error: action.error,
        },
        imagerCapabilities: null,
      };
    case EImagerCapabilitiesAction.UPDATE_IMAGER_CAPABILITIES:
      return {
        status: {
          pending: false,
          completed: true,
          error: null,
        },
        imagerCapabilities: action.imagerCapabilities,
      };
    default:
      return state;
  }
}

export const getOneImagerCapabilities = (
  state: RootState,
  moduleIdentifier: string
): ImagerCapability => {
  if (state.imagerCapabilityStore.imagerCapabilities == null) {
    throw new Error("Imager capabilities is null");
  }
  return state.imagerCapabilityStore.imagerCapabilities.byId[moduleIdentifier];
};
export const getImagerCapabilities = (state: RootState) => {
  if (state.imagerCapabilityStore.imagerCapabilities == null) {
    throw new Error("Imager capabilities is null");
  }
  return state.imagerCapabilityStore.imagerCapabilities;
};
export const getImagerCapabilitiesFetchStatus = (state: RootState) =>
  state.imagerCapabilityStore.status;
